module.exports = __webpack_public_path__ + "media/images/sp/stores/common/icon_youtube-9dd4b85278d610484ee81ffaf18a7e67.png";